import React from "react";
const Floors = require("../../../data/floor.data");

interface Props {
  totalPrice: string;
  modulesCompleted: boolean;
  propertyOptions: any;
  setFloor: (value: any) => void;
  setProperty: (value: any) => void;
  setShowQuote: (value: boolean) => void;
}

const BottombarQuote: React.FC<Props> = ({ totalPrice, modulesCompleted, propertyOptions, setFloor, setProperty, setShowQuote }) => {
  

  return (
    <div className="bottombar-menu-quote">
      <div className="bottombar-quote-content">
        <div className='bottombar-quote-container-title'>Cotiza</div>

        <div className='bottombar-quote-container-data'>
          <div className='bottombar-quote-container-selection'>
            <div className={`bottombar-quote-text-select`}>SELECCIONAR PISO</div>
            <select className={`bottombar-quote-floor-selection`} onChange={(e: any) => setFloor(e.target.value)}>
              {
                Object.keys(Floors.Data).map((floor_key: string, index: number) => (
                  <option key={floor_key} value={floor_key}>{floor_key}</option>
                ))
              }
            </select>
          </div>
          <div className='bottombar-quote-container-middle1'/>
          <div className='bottombar-quote-container-selection'>
            <div className={`bottombar-quote-text-select`}>SELECCIONAR APARTAMENTO</div>
            <select className={`bottombar-quote-floor-selection`} onChange={(e: any) => setProperty(e.target.value)}>
              {
                Object.keys(propertyOptions).map((property_key: any, index: number) => (
                  <option key={property_key} value={property_key}>{property_key}</option>
                ))
              }
            </select>
          </div>
        </div>

        <div className='bottombar-quote-container-value'>
          <div className={`bottombar-quote-text-style1`}>Este apartamento está costando</div>
          <div className={`bottombar-quote-text-style2`}>{totalPrice}</div>
        </div>

        <div className={`bottombar-quote-button ${modulesCompleted ? '':'disabled'}`} onClick={()=>{if(modulesCompleted){setShowQuote(true)}}}>
          <div className={`bottombar-quote-button-text ${modulesCompleted ? 'enabled':'disabled'}`}>Ver cotización</div>
        </div>



      </div>
    </div>
  );
};

export default BottombarQuote;